export const SENTRY_RELEASE: string | undefined = 'a1a52e5a9a9aeee9aae23f53e81bbbb397447a81';
